{
  "appName": "Profiling.app",
  "save": "Save",
  "cancel": "Cancel",
  "or": "or",
  "loading": "Loading…",
  "placeholder": "Here be dragons…",
  "resendVerifyEmail": "Re-send confirmation email",
  "changeLanguage": "Language",
  "form": {
    "saveFailed": "Something went wrong. Please try again."
  },
  "nav": {
    "dashboard": "Dashboard",
    "assignments": "Assignments",
    "briefs": "Briefs",
    "evaluations": "Evaluations",
    "billing": "Billing",
    "myProfiles": "My Profiles",
    "admin": "Admin",
    "settings": "Settings",
    "account": "Account",
    "logout": "Logout",
    "newWorkspace": "New Workspace"
  },
  "error": {
    "title": "Oops, We Dropped One",
    "body": "This shouldn’t have happened. And yet, here we are.",
    "report": "Tell Us What You Saw",
    "home": "Go Home"
  },
  "locales": {
    "en": "English",
    "es_MX": "Español (México)"
  },
  "pagination": {
    "previous": "Previous page",
    "next": "Next page",
    "pageOf": "Page {{page}} of {{pages}}"
  }
}
